<script>
  import { onMount, onDestroy } from "svelte"
  import { fade } from "svelte/transition"

  let currentSlide = 0
  /** @type {NodeJS.Timeout} */
  let timer
  /** Array of slide images */
  const slideCollections = [
    {
      id: 1,
      image: "https://assets.getpercs.com/hub/landing-page-1.png",
      mobile: "https://assets.getpercs.com/hub/landing-mobile-1.png",
    },
    {
      id: 2,
      image: "https://assets.getpercs.com/hub/landing-page-2.png",
      mobile: "https://assets.getpercs.com/hub/landing-mobile-2.png",
    },
    {
      id: 3,
      image: "https://assets.getpercs.com/hub/landing-page-3.png",
      mobile: "https://assets.getpercs.com/hub/landing-mobile-3.png",
    }
  ]

  /**
   * Function to navigate to a specific slide
   * @param {number} index
   */
  function goToSlide(index) {
    currentSlide = index
    resetTimer(true)
  }

  /**
   * Function to move to the next slide automatically
   */
  function nextSlide() {
    currentSlide = (currentSlide + 1) % slideCollections.length
  }

  /**
   * Function to reset the timer
   * @param {boolean} autoPlay
   */
  function resetTimer(autoPlay) {
    clearInterval(timer)
    if (autoPlay) {
      // Change slide every 10 seconds
      timer = setInterval(nextSlide, 10000)
    }
  }

  // Start the timer when the component mounts
  onMount(() => {
    resetTimer(true)
  })

  // Clear the timer when the component is destroyed
  onDestroy(() => {
    clearInterval(timer)
  })
</script>

<div>
  <div class="relative bottom-0 md:bottom-2 flex justify-center items-center">
    {#each slideCollections as image, index (`slide_collection_${image.id}`)}
      {#if currentSlide === index}
        <div class="justify-center" in:fade>
          <img class="hidden md:flex" src={image.image} alt={image.image}>
          <img class="md:hidden" src={image.mobile} alt={image.mobile}>
        </div>
      {/if}
    {/each}
  </div>

  <div class="relative bottom-4 md:bottom-2 flex justify-center items-center">
    <div class="flex items-center space-x-2 relative">
      {#each slideCollections as _, index}
        <button class="rounded-full my-0 mx-1 cursor-pointer {currentSlide === index ? "w-4 h-4 bg-blue-500" : "w-3 h-3 bg-white"} relative z-10" on:click={() => goToSlide(index)}></button>
      {/each}
    </div>
  </div>
</div>
